import React from "react";

interface Props {
  minTableWidth: number;
  emptyText: string;
}
export default function EmptyRow({ emptyText, minTableWidth }: Props) {
  return (
    <div
      className="w-full relative flex  min-w-full min-h-[36px] h-[36px] bg-white "
      style={{ minWidth: minTableWidth }}
    >
      <div
        className={` flex items-center sticky left-0 top-0 z-20 w-[62px] h-full bg-gray-400 -ms-[62px] `}
      />
      <div className="sticky flex items-center justify-center left-1/2 -translate-x-1/2  ">
        <span className="text-sm text-secondary text-center px-2">
          {emptyText || "There are no any tickets"}
        </span>
      </div>
    </div>
  );
}
